import React from 'react';
import ReactDOM from 'react-dom';
import { HelmetProvider } from 'react-helmet-async';

import App from './App';

import './i18n';

import theme from 'theme';

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <App theme={theme} />
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
